import { returnsApiProxy } from '@/redux/api/returns-api-slice'
import type { ReturnsApiCancelWfpContractRequest } from '@itsrever/rever-api'
import { useMutation } from '@tanstack/react-query'

const cancelCover = async (req: ReturnsApiCancelWfpContractRequest) => {
  const { data } = await returnsApiProxy.cancelWfpContract(req)

  return data
}

export const useCancelCover = () => {
  return useMutation({
    mutationFn: cancelCover
  })
}
